import { useState } from 'react';

import { Icons } from '@/assets/icons/icons';
import {
  PopoverRoot,
  PopoverTrigger,
  PopoverContent,
} from '@/components/ui/popover/popover';
import { cn } from '@/lib/utils';
import { formatFileSize } from '@/utils/files';

import { useCardMetrics } from '../internals/useCardMetrics';
import { ICON_CLASS, sizingClass } from '../tokens';

import type { catalog } from '@littlebird/action-cards-view';
import type { ComponentFn } from '@littlebird/action-cards-view/react';

export const Attachment: ComponentFn<typeof catalog, 'Attachment'> = ({
  props,
}) => {
  const metrics = useCardMetrics();
  const [open, setOpen] = useState(false);
  return (
    <PopoverRoot open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          title={props.filename}
          aria-label={`Attachment: ${props.filename}`}
          className={cn(
            'inline-flex w-fit max-w-full items-center gap-[calc(6*var(--ac-u))] rounded-[calc(6*var(--ac-u))] text-[length:calc(12.5*var(--ac-u))] text-foreground',
            metrics.preview
              ? 'min-h-[var(--ac-pill-h)] bg-surface-hover px-[calc(6*var(--ac-u))]'
              : 'h-[calc(28*var(--ac-u))] border border-border bg-transparent pl-[calc(8*var(--ac-u))] pr-[calc(6*var(--ac-u))]',
            sizingClass(props.sizing)
          )}
        >
          <Icons.paperclip
            className={cn(ICON_CLASS, 'shrink-0')}
            aria-hidden="true"
          />
          <span className="min-w-0 truncate">{props.filename}</span>
          {typeof props.size === 'number' ? (
            <span className="shrink-0 text-foreground-muted">
              {formatFileSize(props.size).replace(/\.0+(?=\s)/, '')}
            </span>
          ) : null}
        </button>
      </PopoverTrigger>
      <PopoverContent
        className="max-w-[min(320px,90vw)] break-words text-[13px]"
        align="start"
      >
        {props.filename}
      </PopoverContent>
    </PopoverRoot>
  );
};
